import { makeCommsPage } from './commsPage'
import { CommsPipelineView } from '../components/views/commsPipelineView'

export default makeCommsPage({
    title: 'Pipeline',
    intro: 'Run each stage of the inbound pipeline from here — sweep, preprocess, case identity, extraction, reconcile, thread summaries — and watch the same jobs run on the cloud schedule.',
    probeUrl: 'comms/pipeline/status',
    View: CommsPipelineView,
    className: 'commsPipeline',
})
